<template>
  <div class="col-sm-12 editor pb-3">
    <Transition name="fade">
      <div
        v-if="inspectionTemplate!=null"
        class="col-sm-12 editor-form p-3"
      >
        <h3>{{ inspectionTemplate.name }}</h3>
        <!--        Generic info field-->
        <div class="col-12 nopads mt-2 mb-2">
        <textarea
            id="info"
            v-model="info"
            class="form-control form-control-sm nopads p-1"
            :placeholder="$t('ins_report.info')"
            rows="4"
            style="resize: vertical; max-height: calc(1.5em * 6);"
        ></textarea>
        </div>

        <div class="col-sm-12 form-data nopads pb-3 mb-2 px-2">
          <div class="row inspection-row" v-for="(inspectable) of inspectables" :key="inspectable.id">
            <inspection-result :ref="'result'+inspectable.id" :inspectable-item="inspectable" :inspection-type="inspectionTemplate.type"
                               @value-changed="updateValues" @result-changed="checkIfReady"/>
          </div>
        </div>
        <div class="col-sm-12 d-flex justify-content-end">
          <button class="btn btn-success form-button" :disabled="!canSubmit||loading" @click.stop="askForSubmission">
            {{ $t('common.send') }}
          </button>
        </div>
      </div>
    </Transition>
    <div
      v-if="inspectionTemplate==null"
      class="col-sm-12"
    >
      {{ $t('inspection.no_template_found') }}
    </div>
    <base-modal
      v-if="submitModal"
      :hide-header="true"
      :hide-footer="true"
    >
      <div class="col-sm-12 pb-1">
        <h3 class="pb-2 editor-header">{{ $t('ins_wizard.submit_confirm') }}</h3>
        <span>{{ $t('ins_wizard.submit_confirm_info') }}</span>
      </div>
      <div class="col-12 button-container">
        <button
          class="btn btn-sm btn-secondary form-button"
          @click="cancelSubmit"
        >
          {{ $t('common.no') }}
        </button>
        <button
          class="btn btn-success form-button"
          @click="submitInspection"
        >
          {{ $t('common.yes') }}
        </button>
      </div>
    </base-modal>
    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
  </div>
</template>

<script>
import {attachmentHelper} from '../../mixins/AttachmentMixin'
import {types as inspectableTypes} from "../../../modules/Inspectable";
import BaseModal from "@/components/BaseModal";
import InspectionResult from "@/components/inspections/wizard/InspectionResult";
import {toRaw} from "vue";

export default {
    name: 'InspectionForm',
    components: {InspectionResult, BaseModal},
    mixins: [attachmentHelper],
    props: {
        inspectionTemplate: {
            type: Object,
            default: null
        },
        allowSkipping: {
            type: Boolean,
            default: function () {
                return false
            }
        },
        loading: {
            type: Boolean,
            default: false
        },
    },
    data: function () {
        return {
            canSubmit: false,
            submitModal: false,
            inspectionOptions: [
                {value: 1, text: this.$t('inspection.options.not_tested')},
                {value: 2, text: this.$t('inspection.options.okay')},
                {value: 3, text: this.$t('inspection.options.defects')},
                {value: 4, text: this.$t('inspection.options.ban')}
            ],
            inspectableTypes,
            inspectionType: this.inspectionTemplate.type,
            inspectionName: this.inspectionTemplate.name,
            inspectables: this.inspectionTemplate.inspectables,
            inspectableValues: [],
            inspectableInfo: [],
            inspectableTypeResults: [],
            info: null,
            photos: {},
            HARJA_INSPECTION_REPORT_TYPE: 7
        }
    },
    created() {
        this.inspectables = this.inspectionTemplate.inspectables
        this.inspectionType = this.inspectionTemplate.name
        this.inspectableTypeResults = this.inspectionTemplate.inspectables.map(i => ({
            none: undefined,
            number: { number: null },
            text: { text: "" },
            select_single: { select_single: null },
            select_multi: { select_multi: [] },
            boolean: { boolean: null },
        }[inspectableTypes[i.type]]))
        for (let i = 0; i < this.inspectionTemplate.inspectables.length; i++) {
            const inspectable = this.inspectionTemplate.inspectables[i];
            if (inspectableTypes[inspectable.type] === 'none') continue;
            this.inspectableValues[i] = 2;
        }
    },
    methods: {
        getValueRange(inspectable) {
            if (inspectable.range) {
                let text = inspectable.range.min === undefined ? '' : (inspectable.range.min + ' - ')
                if (inspectable.range.max !== undefined) {
                    text += inspectable.range.max
                }
                return text
            }
            return ''
        },
        getTitle: function (type) {
            switch (type) {
                case 1:
                    return this.$t('inspection_template.type.weekly')
                case 2:
                    return this.$t('inspection_template.type.monthly')
                case 3:
                    return this.$t('inspection_template.type.annually')
                case 4:
                    return this.$t('inspection_template.type.deployment')
                case 5:
                    return this.$t('inspection_template.type.daily')
            }
        },
        getInspectionResultsFromForm: function () {
            // Loop through inspectables to generate results
            var results = []

            for (var i = 0; i < this.inspectables.length; i++) {
                var inspectable = this.inspectables[i]
                // No type/ default inspectable value handling
                var value = this.inspectableValues[i]
                if (value === undefined) {
                    value = 1 // Skipped
                } else if (value.none) {
                    value = value.none
                }

                const key = 'result'+inspectable.id
                const element = Array.isArray(this.$refs[key]) ? this.$refs[key][0] : this.$refs[key]
                var info = element.getInfo()
                if (info === undefined) {
                    info = ''
                }

                let typeResult = this.inspectableTypeResults[i]
                results.push({
                    id: '',
                    inspectable: inspectable.name,
                    inspectable_id: inspectable.id,
                    result: value,
                    info: info,
                    ...typeResult,
                })
            }
            var d = new Date()
            var createTime = d.toISOString()
            return {
                created: createTime,
                results: results,
                info: this.info
            }
        },

        askForSubmission() {
            this.submitModal = true
        },

        cancelSubmit() {
            this.submitModal = false
        },

        submitInspection: function () {
            this.submitModal = false
            // Read photos
            this.photos = {}
            for (let i = 0; i < this.inspectionTemplate.inspectables.length; i++) {
                const inspectable = this.inspectionTemplate.inspectables[i]
                const key = 'result' + inspectable.id
                let resultEl = this.$refs[key]
                if(Array.isArray(resultEl)) {
                    resultEl = resultEl[0]
                }
                const photo = resultEl.getPhoto()
                if (photo) {
                    this.photos[inspectable.id] = [photo]
                }
            }
            this.$emit('onSubmitResults', this.getInspectionResultsFromForm(), this.photos);
        },

        isValidInput(inspectable, value) {
            if (value === undefined || value === null || value.length < 1) {
                return null
            }
            return this.getValidNumber(inspectable, value) !== undefined
        },

        getValidNumber(inspectable, value) {
            if (inspectable.range && value) {
                if (inspectable.range.max !== undefined && inspectable.range.min !== undefined) {
                    if (value <= inspectable.range.max && value >= inspectable.range.min) {
                        return value
                    }
                    return undefined
                } else if (inspectable.range.max !== undefined && value <= inspectable.range.max) {
                    return value
                } else if (inspectable.range.min !== undefined && value >= inspectable.range.min) {
                    return value
                }
                return undefined
            }
            return value
        },

        updateValues(inspectableId, value) {
            const index = this.inspectionTemplate.inspectables.findIndex(item => item.id === inspectableId)
            this.inspectableValues[index] = {"none": value}
            this.checkIfReady()
        },

        checkIfReady() {
            for (let i = 0; i < this.inspectionTemplate.inspectables.length; i++) {
                const inspectable = this.inspectionTemplate.inspectables[i]
                const key = 'result' + inspectable.id
                let resultEl = this.$refs[key]
                if(Array.isArray(resultEl)) {
                    resultEl = resultEl[0]
                }
                this.inspectableTypeResults[i] = resultEl.getResultSet()
                const type = inspectableTypes[this.inspectionTemplate.inspectables[i].type];
                switch (type) {
                    case "number":
                        if (this.inspectableTypeResults[i].number == null) {
                            this.canSubmit = false;
                            return;
                        }
                        break;
                    case "boolean":
                        if (this.inspectableTypeResults[i].boolean == null) {
                            this.canSubmit = false;
                            return;
                        }
                        break;
                    case "risk_assessment":
                        // Check if additional info is given on false result
                        const key = 'result' + inspectable.id
                        const info = this.$refs[key][0].getInfo()
                        if (this.inspectableTypeResults[i].boolean === null ||
                            (this.inspectableTypeResults[i].boolean === false && info.length < 5)) {
                            this.canSubmit = false;
                            return;
                        }
                        break;
                    case "select_single":
                        if (this.inspectableTypeResults[i].select_single == null) {
                            this.canSubmit = false;
                            return;
                        }
                        break;
                    case "select_multi":
                        if (this.inspectableTypeResults[i].select_multi == null) {
                            this.canSubmit = false;
                            return;
                        }
                        break;
                    case "text":
                        if (this.inspectableTypeResults[i].text === null || this.inspectableTypeResults[i].text.length < 1) {
                            this.canSubmit = false;
                            return;
                        }
                        break;
                }
            }
            // Default set
            this.canSubmit = this.inspectableValues.length === this.inspectables.length;
        }
    }
}
</script>

<style>
p {
    padding-left: .5em;
    padding-right: .5em;
    font-size: 1.2em;
}

div.info {
    margin-left: 30px;
}
</style>
